/**
 * Co-learning submissions use a Firestore doc id (`submission.id`) that differs from
 * the Artist Wall artwork id (`submission.artworkId`). Reactions/notifications should
 * prefer the stable artwork id when present so counts stay in sync across surfaces.
 */
export function getReactionArtworkId(item) {
  if (!item) return null;
  return item.artworkId || item.id || null;
}

export function isNotificationRead(notification) {
  if (!notification) return false;
  return notification.isRead === true || notification.read === true;
}

const LAST_SEEN_REACTIONS_KEY = (uid) => `reaction_notifications_last_seen_${uid}`;

/** When the user last opened the reactions panel (ms since epoch). */
export function getReactionsLastSeenMs(uid) {
  if (!uid) return 0;
  try {
    const raw = localStorage.getItem(LAST_SEEN_REACTIONS_KEY(uid));
    const parsed = raw ? parseInt(raw, 10) : 0;
    return Number.isFinite(parsed) ? parsed : 0;
  } catch {
    return 0;
  }
}

export function setReactionsLastSeenMs(uid, ms = Date.now()) {
  if (!uid) return;
  try {
    localStorage.setItem(LAST_SEEN_REACTIONS_KEY(uid), String(ms));
  } catch {
    /* ignore quota errors */
  }
}

export function isFirestoreNotificationId(id) {
  return typeof id === "string" && id.length > 0 && !id.startsWith("reaction-");
}
